<template>
  <div>
    <v-card>
      <v-system-bar dark color="grey darken-1" height="50">
        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <span v-if="etapeEffective.length > 0">
          {{ etapeEffective[0].abbr_bailleur }} -
          {{ etapeEffective[0].ll_parcours_effectif }} -
          {{ etapeEffective[0].ll_parcours }} -
         
          {{ etapeEffective[0].ll_etape }}</span
        >
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>

      <v-card-text v-if="etapeEffective.length > 0">
        <v-card class="mb-4">
         
          <!--  <v-card-title>
            fiche/index etapeEffective[0]
          </v-card-title> 
          <v-card-text>
           <div>
              {{etapeEffective[0]}}
            </div>
            <div>
              etapeEffective[0].parcours_effectif_id_parcours_effectif :
              {{ etapeEffective[0].parcours_effectif_id_parcours_effectif }}
            </div>
            <div>
              etapeEffective[0].id :
              {{ etapeEffective[0].id }}
            </div>
            <div>
              etapeEffective[0].ll_parcours :
              {{ etapeEffective[0].ll_parcours }}
            </div>
            <div>
              etapeEffective[0].ll_parcours_effectif :
              {{ etapeEffective[0].ll_parcours_effectif }}
            </div>
          </v-card-text>
           -->
       <!--    <v-card-text>
            <div
              class="white ma-4 pa-4"
              v-for="(etapeEffective, index) in etapeEffective[0].recapVerified"
              :key="index"
            >
              <div>
                etapeEffective.ll_etape :
                {{ etapeEffective.ll_etape }}
              </div>
              <div>
                etapeEffective.ll_details_etapes :
                {{ etapeEffective.ll_details_etapes }}
              </div>

              <div>
                etapeEffective.type_champ :
                {{ etapeEffective.type_champ }}
              </div>
              <div>
                etapeEffective.valueRecapHommes :
                {{ etapeEffective.valueRecapHommes }}
              </div>
              <div>
                etapeEffective.valueRecapFemmes :
                {{ etapeEffective.valueRecapFemmes }}
              </div>
              <div>
                etapeEffective.valueCalcul :
                {{ etapeEffective.valueCalcul }}
              </div>
            </div>
          </v-card-text> -->
          <v-card-text>
            <ficheGlobale
              :detailEtapes="etapeEffective[0].recapVerified"
              :etapeEffective="etapeEffective[0]"
            />
            <br />
            <ficheCalculee
              v-if="user.role != 'superviseur'"
              :detailEtapes="etapeEffective[0].recapComputed"
              :etapeEffective="etapeEffective[0]"
            />
            <div
              v-for="(membre, index) in MembresDuGroupe"
              :key="index"
              v-if="user.role != 'superviseur'"
            >
              <ficheIndividuelle
                @initCompute="initCalcul"
                :detailEtapes="detailEtapes"
                :membre="membre"
                :etapeEffective="etapeEffective[0]"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions, createLogger } from "vuex";
export default {
  data() {
    return {
      MembresDuGroupe: [],
      detailEtapes: [],
      recapAlpnanumeriqueFemme: "",
      recapAlpnanumeriqueHomme: "",
      recapChiffreFemme: "",
      recapChiffreHomme: "",
      recapCheckboxHomme: {},
      recapCheckboxFemme: {},
      recapDate: "",
      loading: false,
      payload: {},
      payloadCalcul: {},
      disabled: false,
    };
  },
  components: {
    ficheIndividuelle: require("@/components/groupes/ficheIndividuelle.vue")
      .default,
    ficheGlobale: require("@/components/groupes/ficheGlobale.vue").default,
    ficheCalculee: require("@/components/groupes/ficheCalculee.vue").default,
  },

  created() {
    let payload = {
      IdParcoursEffectif: this.$route.query.parcoursEffectif,
      idEtape: this.$route.query.idEtape,
    };

    this.get_etape_effective_by_parcours_et_etape(payload);
    this.GetMembresDuGroupe(this.$route.query.idGroupe);
    this.GetDetailsEtape(this.$route.query.idEtape);
  },

  mounted() {
    if (this.user.role != "superviseur") {
      this.disabled = true;
      console.log("mounted", this.disabled);
    }
  },

  methods: {
    initCalcul(payload) {
      console.log("initCalcul", payload);
      let self = this;
      let objet = self.etapeEffective[0].recapComputed;

      if (!self.etapeEffective[0].recapComputed) {
        self.detailEtapes.forEach(function (item) {
          var etap = item;
          etap.valueRecapFemmes = "0";
          etap.valueRecapHommes = "0";
          etap.valueCalcul = "0";
          etap.valueNombreMembre = "0";
          objet.push(etap);
        });

        console.log("construis OBJET Computed");

        var ref = this.$firebase
          .firestore()
          .collection("etapes_effectives")
          .doc(self.etapeEffective[0].id);

        ref
          .set(
            {
              recapComputed: objet,
            },
            { merge: true }
          )
          .then(function () {
            let load = {
              IdParcoursEffectif: self.$route.query.parcoursEffectif,
              idEtape: self.$route.query.idEtape,
            };

            self.get_etape_effective_by_parcours_et_etape(load);
          });
      } else {
        if (payload.typeChamp.value === "2") {
          /* Alphanumérique */
          console.log("typeChamp ----alpha ", payload.typeChamp.value);
          var arrayToSend = [];
          self.etapeEffective[0].recapComputed.forEach(function (item, index) {
            if (item.id === payload.detailEtape.id) {
              console.log("ll_details_etapes", item.ll_details_etapes);

              switch (payload.action) {
                case "add":
                  console.log("add", index);

                  item.valueNombreMembre++;

                  break;
                case "modify":
                  console.log("modify", index);
                  break;
                case "delete":
                  console.log("delete", index);

                  item.valueNombreMembre--;
              }
            }

            arrayToSend.push(item);
          });
          console.log("arrayToSend alpha", arrayToSend);
          self.saveToTotal(arrayToSend);
        } else if (payload.typeChamp.value != 1) {
          console.log("typeChamp tsy alpha", payload.typeChamp.value);
          console.log("payload", payload);
          //console.log("recapComputed",self.etapeEffective[0].recapComputed)
          var arrayToSend = [];
          self.etapeEffective[0].recapComputed.forEach(function (item, index) {
            if (item.id === payload.detailEtape.id) {
              console.log("ll_details_etapes", item.ll_details_etapes);
              switch (payload.action) {
                case "add":
                  console.log("add", index);
                  if (payload.sexe === 0) {
                    item.valueRecapFemmes++;
                  } else {
                    item.valueRecapHommes++;
                  }

                  break;
                case "modify":
                  console.log("modify", index);
                  break;
                case "delete":
                  console.log("delete", index);
                  if (payload.sexe === 0) {
                    item.valueRecapFemmes--;
                  } else {
                    item.valueRecapHommes--;
                  }
              }
            }

            arrayToSend.push(item);
          });
          self.saveToTotal(arrayToSend);
          console.log(arrayToSend);
        } else {
          console.log("Addition-----");
          var arrayToSend = [];
          self.etapeEffective[0].recapComputed.forEach(function (item, index) {
            if (item.id === payload.detailEtape.id) {
              switch (payload.action) {
                case "add":
                  /* **************** */
                  console.log("addAddition");
                  var temp =
                    parseFloat(item.valueCalcul) + parseFloat(payload.value);
                  item.valueCalcul = temp.toString();
                  /* **************** */
                  break;
                case "modify":
                  /* **************** */
                  console.log("modifyAddition");
                  var orig = payload.oldValue;
                  /*  item.valueCalcul =
                    parseFloat(item.valueCalcul) +
                    parseFloat(payload.value - orig); */
                  console.log("orig-----", orig);
                  console.log(
                    "payload.value----",
                    parseFloat(payload.value).toFixed(2)
                  );
                  console.log("From Total", item.valueCalcul);

                  var difference = parseFloat(
                    parseFloat(payload.value).toFixed(2) -
                      parseFloat(orig).toFixed(2)
                  )
                    .toFixed(2)
                    .toString();

                  console.log("difference", difference);

                  var temp =
                    parseFloat(item.valueCalcul) + parseFloat(difference);

                  item.valueCalcul = parseFloat(temp.toString()).toFixed(2);

                  console.log("modifyAdditionvita", item.valueCalcul);

                  /* ************************ */

                  break;
                case "delete":
                  /* **************** */
                  console.log("deleteAddition");
                  /*  item.valueCalcul =
                    parseFloat(item.valueCalcul) - parseFloat(payload.value); */

                  item.valueCalcul = _.subtract(
                    parseFloat(item.valueCalcul),
                    parseFloat(payload.value).toString()
                  );
                /* **************** */
              }
              console.log("valueCalcultoSend", item.valueCalcul);
            }

            arrayToSend.push(item);
          });
          self.saveToTotal(arrayToSend);
        }
      }
    },

    total(event, index) {
      if (this.user.role === "superviseur") {
        let self = this;
        var oldObject = self.etapeEffective[0].recapVerified;
        var oldLine = oldObject[index];
        oldLine.valueCalcul = event.target.value;
        self.payloadCalcul = oldObject;
        self.updateTotal();
      }
    },
    recap(event, index, sexe) {
      if (this.user.role === "superviseur") {
        let self = this;
        var oldObject = self.etapeEffective[0].recapVerified;

        var oldLine = oldObject[index];

        var champ = "";
        if (sexe === 0) {
          champ = "valueRecapFemmes";
          oldLine[champ] = event.target.value;
        } else {
          champ = "valueRecapHommes";
          oldLine[champ] = event.target.value;
        }
        self.payload = oldObject;
        self.updateRecap();
      }
    },
    updateTotal() {
      let self = this;
      console.clear();
      console.log("updateTotal", self.payloadCalcul);
      var ref = this.$firebase
        .firestore()
        .collection("etapes_effectives")
        .doc(self.etapeEffective[0].id);
      ref.set(
        {
          recapVerified: self.payloadCalcul,
        },
        { merge: true }
      );
    },
    updateRecap() {
      let self = this;
      console.clear();
      console.log("updateRecap", self.payload);
      var ref = this.$firebase
        .firestore()
        .collection("etapes_effectives")
        .doc(self.etapeEffective[0].id);
      ref.set(
        {
          recapVerified: self.payload,
        },
        { merge: true }
      );
    },

    saveToTotal(dataTosave) {
      let self = this;

      var ref = this.$firebase
        .firestore()
        .collection("etapes_effectives")
        .doc(self.etapeEffective[0].id);
      ref.set(
        {
          recapComputed: dataTosave,
        },
        { merge: true }
      );
    },

    gotoficheIndividuelle(detailEtapes, membre, etapeEffective) {
      console.log("detailEtapes", detailEtapes);
      console.log("membre", membre);
      console.log("etapeEffective", etapeEffective);
    },
    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },
    GetMembresDuGroupe(idGroupe) {
      let self = this;
      this.$store.commit(
        "Loading/START_BUSY_STATE",
        "fiches GetMembresDuGroupe",
        {
          root: true,
        }
      );
      this.$firebase
        .firestore()
        .collection("membres")
        .where("id_groupe", "==", idGroupe)
        .orderBy("nom")
        .get()
        .then(
          (snapshot) => {
            snapshot.forEach(function (doc) {
              self.MembresDuGroupe.push({
                ...doc.data(),
                id: doc.id,
              });
            });
          },
          (error) => {
            console.log(error);
            let snackbar = {};
            snackbar.showSnackbar = true;
            snackbar.snackbarContent = error.message;
            this.$store.commit("Snackbar/SET_SNACKBAR", snackbar, {
              root: true,
            });
            this.$store.commit(
              "Loading/END_BUSY_STATE",
              "Error GetMembresDuGroupe",
              {
                root: true,
              }
            );
          }
        );
    },
    GetDetailsEtape(idEtape) {
      let self = this;
      this.$store.commit(
        "Loading/START_BUSY_STATE",
        "fiches GetMembresDuGroupe",
        {
          root: true,
        }
      );
      this.$firebase
        .firestore()
        .collection("detailEtapes")
        .where("etape_id_etape", "==", idEtape)
        .orderBy("rangDetailEtape")
        .get()
        .then(
          (snapshot) => {
            snapshot.forEach(function (doc) {
              self.detailEtapes.push({
                ...doc.data(),
                id: doc.id,
              });
            });
            //console.log(self.detailEtapes);
          },
          (error) => {
            console.log(error);
            let snackbar = {};
            snackbar.showSnackbar = true;
            snackbar.snackbarContent = error.message;
            this.$store.commit("Snackbar/SET_SNACKBAR", snackbar, {
              root: true,
            });
            this.$store.commit(
              "Loading/END_BUSY_STATE",
              "Error GetMembresDuGroupe",
              {
                root: true,
              }
            );
          }
        );
    },
    ...mapActions({
      get_etape_effective_by_parcours_et_etape:
        "EtapeEffective/get_etape_effective_by_parcours_et_etape",
    }),
  },
  computed: {
    ...mapState({
      etapeEffective: (state) => state.EtapeEffective.etapeEffective,
      user: (state) => state.Auth.user,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
